import { colors, fonts } from 'shared/lib'
import media, { sizes } from 'shared/lib/media'
import styled from 'styled-components'

import SizeGuide from 'productTemplate/components/SizeGuide'

interface ISizeTileProps {
  isSelected: boolean
}

export const ProductPickerWrapper = styled.div`
  margin-bottom: 40px;
  ${media.large`
    margin-bottom: 30px;
  `}
`

export const TopLabelSection = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
  ${media.large`
    padding-bottom: 20px;
  `}
`

export const SizingLabel = styled.label`
  ${fonts.SUBTITLE_2}
  color: ${colors.FC2_BLACK}
`

export const StyledSizeGuide = styled(SizeGuide)`
  flex-basis: 30%;
  min-width: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const SizeOptionWrapper = styled.div`
  display: grid;
  gap: 5px;
  grid-template-columns: repeat(5, 1fr);
`

export const SizeOptionTile = styled.button`
  ${fonts.SUBTITLE_2}
  cursor: pointer;
  line-height: 42px;
  border: 1.5px solid
    ${({ isSelected }: ISizeTileProps) =>
      isSelected ? colors.FC2_BLACK : colors.FC2_LIGHTEST_GREY};

  @media (min-width: ${sizes.large / 16}em) {
    &:hover {
      border: 1.5px solid
        ${({ isSelected }: { isSelected: boolean }) =>
          isSelected ? colors.FC2_BLACK : colors.FC2_GREY};
    }
  }
`

export const SizeInputField = styled.button`
  width: 100%;
  min-height: 45px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${fonts.SUBTITLE_2};
  text-transform: none;
  color: ${colors.FC2_BLACK};
  border: 1px solid ${colors.FC2_BLACK};
  padding: 0 20px;
  margin-bottom: 16px;
  ${media.large`
    text-transform: uppercase;
    min-height: 40px;
    margin-bottom: 20px;
    border: 1.5px solid ${colors.FC2_BLACK};
  `}
`

export const MobileSizePickerModalTitle = styled.h3`
  ${fonts.SUBTITLE_1}
  margin: 0;
  text-transform: uppercase;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

export const MobileOverlayPanel = styled.div<{ $extraMargin?: boolean }>`
  margin: ${({ $extraMargin }) => ($extraMargin ? '30px 20px' : '16px 20px 30px')};
`

export const SizeLabel = styled.h4`
  ${fonts.SUBTITLE_2}
`
